import { Box } from '@mui/material';
import React from 'react';
import { PromotionPrerequisiteIssue } from '../../services/BaseBackendService';
import { StyledButton } from '../styles/StyledButtons';
import StyledModal from '../styles/StyledModal';
import { StyledTypography } from '../styles/styles';
import {
  fundStatusInvestorOverrideLeadSentence,
  promotionIssueDisplayText,
} from './FundOpportunityAdmin/promotionPrerequisiteMessages';

interface PromotionPrerequisiteAckModalProps {
  open: boolean;
  issues: PromotionPrerequisiteIssue[];
  title?: string;
  inProgress?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const PromotionPrerequisiteAckModal: React.FC<PromotionPrerequisiteAckModalProps> = ({
  open,
  issues,
  title = 'Investor action - prerequisites',
  inProgress,
  onCancel,
  onConfirm,
}) => {
  const fundOverrideLead = fundStatusInvestorOverrideLeadSentence(issues);
  const modalTitle = fundOverrideLead ? 'Confirm investor action' : title;

  return (
    <StyledModal
      open={open}
      onClose={() => {
        if (!inProgress) {
          onCancel();
        }
      }}
      title={modalTitle}
      tone="tone1"
      type="warning"
      maxWidth="sm"
      fullWidth
      actions={
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <StyledButton
            variant="outlined"
            buttonVariant="inactiveOrCancel"
            disabled={!!inProgress}
            onClick={onCancel}
          >
            Cancel
          </StyledButton>
          <StyledButton variant="contained" disabled={!!inProgress} onClick={onConfirm}>
            {fundOverrideLead ? 'Yes, override and continue' : 'Proceed anyway'}
          </StyledButton>
        </Box>
      }
    >
      {fundOverrideLead ? (
        <StyledTypography tone="tone1" sx={{ fontSize: '1rem' }}>
          {fundOverrideLead}
        </StyledTypography>
      ) : (
        <>
          <StyledTypography tone="tone1" sx={{ mb: 2, fontSize: '1rem' }}>
            The following applies to this investor action. You can still proceed, but it is not
            recommended unless you intend to override the restriction.
          </StyledTypography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {issues.map((row) => (
              <Box
                component="li"
                key={`${row.issue}-${row.overrideRequestParam ?? ''}-${promotionIssueDisplayText(row)}`}
              >
                <StyledTypography tone="tone1" sx={{ fontSize: '1rem' }}>
                  {promotionIssueDisplayText(row)}
                </StyledTypography>
              </Box>
            ))}
          </Box>
        </>
      )}
    </StyledModal>
  );
};

export default PromotionPrerequisiteAckModal;
